import React from 'react';
import { Link } from 'gatsby';
import { Show } from './../../elements/HomeElements';

const Showcase = () => (
    <Show>
        <div className="container">
            <div className="text-block">
                <p></p>
                <h3>
                    Award winning non-profit organisation founded by <br /> <span className="effect">Zanele Phakathi</span>
                </h3>
            </div>
            <Link to="/donate" className="btn">Donate Now</Link>
        </div>
    </Show>
)

export default Showcase;